export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14318.99035a54.jpg";